import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/web3-theme.css";
import "./styles/blue-overrides.css";
import "./ui/tokens/spacing.css";
import "./ui/tokens/surfaces.css";
import "./ui/layout/landing.css";
import { initTheme } from "./utils/theme";
import axios from "axios";

import { headerData } from "./components/GenericFunctions";
import reportWebVitals from "./reportWebVitals";
import { logWebVitals } from "./utils/reportWebVitalsLogger";
import { registerChunkLoadRecovery } from "./utils/chunkLoadRecovery";
import BaseUrl from "./utils/BaseUrl";
import { getApiToken, storeApiToken } from "./utils/ApiPaths";
import { isPatientSessionActive } from "./utils/patientSession";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import App from "./App";
import "react-bootstrap-country-select/dist/react-bootstrap-country-select.css";

initTheme();
// Drop stale patient sessions after end-of-day expiry; keep valid day sessions
isPatientSessionActive();

Object.assign(axios.defaults.headers.common, headerData);

axios.interceptors.request.use((config) => {
  if (BaseUrl.usePatientPortalApi) {
    const token = getApiToken() || BaseUrl.patientPortalApiToken;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

registerChunkLoadRecovery();

if (process.env.NODE_ENV !== "production") {
  require("dotenv").config();
}

/**
 * Most /api/** routes need Bearer. Prefer issued client token; fall back to static api-token.
 */
function ensurePatientPortalApiToken() {
  if (!BaseUrl.usePatientPortalApi) {
    return Promise.resolve();
  }
  if (getApiToken()) {
    return Promise.resolve();
  }
  // Immediate fallback so AppointmentDB can call while /api/auth/token is in flight
  if (BaseUrl.patientPortalApiToken) {
    storeApiToken(BaseUrl.patientPortalApiToken);
  }
  const url = `${BaseUrl.patientPortalApiBaseUrl.replace(/\/$/, "")}/api/auth/token`;
  return axios
    .post(
      url,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          "X-Client-Secret": BaseUrl.patientPortalClientSecret,
        },
      }
    )
    .then((resp) => {
      const body = resp.data || {};
      const token =
        (body.workAreaVo && body.workAreaVo.token) || body.token || null;
      if (token) {
        storeApiToken(token);
      }
    })
    .catch((err) => {
      console.warn(
        "Could not issue patientportalapi client token; using static api-token if set",
        err && err.message
      );
    });
}

const container = document.getElementById("root");
const root = createRoot(container);

ensurePatientPortalApiToken().finally(() => {
  root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  );
});

reportWebVitals(logWebVitals);
